module.exports = __webpack_public_path__ + "static/media/cancel-join.cf84c274.svg";